;(function( window, document, $, undefined ) {
  'use strict';

  var events = (function() {

    var $private = {};
    var $public = {};

    $public.mainSlider = function() {
      var mainSlider = $('.dd-main-bxslider').bxSlider({
        controls: false,
        pager: true,
        onSliderLoad : function() {
          $('.dd-section-main-slider').css('visibility' , 'visible');
          if($(".dd-main-bxslider li").length < 4) {
            $('.dd-arrows-banner').hide();
            $('.bx-controls').hide();
          }
        }
      });

      $('.dd-arrows-banner .dd-arrow-left').on('click', function(){
        mainSlider.goToPrevSlide();
      });

      $('.dd-arrows-banner .dd-arrow-right').on('click', function(){
        mainSlider.goToNextSlide();
      });
    }


    $public.eventSlider = function() {
      var mainEventSlider = $('.dd-slide-event').bxSlider({
        controls: false,
        pager: false,
        onSliderLoad : function() {
          $('.dd-box-slide').css('visibility' , 'visible');

          if($(".dd-slide-event li").length <= 3) {
            $('.dd-box-slide .dd-small-arrow-slider').addClass('dd-hide');
          }
        }
      });

      $('.dd-arrow-left').on('click', function(){
        mainEventSlider.goToPrevSlide();
      });

      $('.dd-arrow-right').on('click', function(){
        mainEventSlider.goToNextSlide();
      });
    }

    return $public;
  })();

  // Global
  window.events = events;
  events.mainSlider();
  events.eventSlider();

})( window, document, jQuery );

$(window).load(function() {
});
